<div
  class="w-8 h-8 border-[1px] border-gray-400 rounded-md flex items-center justify-center cursor-pointer"
  (click)="onToggle()"
>
  <div
    class="w-[20px] h-[20px] rounded-sm"
    [class.bg-blue-900]="selected"
    [class.bg-white]="!selected"
  ></div>
</div>
